class CantidadSelector extends HTMLElement {
    constructor() {
      super();
  
      this.lineKey = this.getAttribute('data-line-key');
      this.cantidadField = this.querySelector('[js-cantidad-field]');
      this.quantityBtns = this.querySelectorAll('[js-quantity-btn]');
      this.VariantsJson = JSON.parse(this.querySelector('#VariantsJson').textContent);
      this.cartModal = document.querySelector("cart-modal");
      this.loader = this.cartModal?.shadowRoot.querySelector(".loading-overlay");
      this.quickAddBtn = this.querySelector('quick-add-button');
      this.sectionId = this.cartModal?.getAttribute("data-section-id");
      this.variantTitle = this.getAttribute("data-variant-title");
      this.cantidadPosition = parseInt(this.getAttribute("data-position"));
    }
  
    connectedCallback() {
      this.quantityBtns.forEach((btn) => {
        btn.addEventListener('click', this.handleCantidadChange.bind(this));
      });
    }
  
    handleCantidadChange({ currentTarget }) {
      const actionType = currentTarget.getAttribute('data-type');
      const currentQuantity = parseInt(this.cantidadField.value);
      const minQuantity = parseInt(this.cantidadField.getAttribute('min'));
      const maxQuantity = parseInt(this.cantidadField.getAttribute('max'));
      let newQuantity = currentQuantity;

      if (actionType === 'increment' && currentQuantity < maxQuantity) {
        newQuantity++;
      } else if (actionType === 'decrement' && currentQuantity > minQuantity) {
        newQuantity--;
      }
  
      if (newQuantity !== currentQuantity) {
        this.updateCantidad(newQuantity);
      }
    }
  
    async updateCantidad(newQuantity) {
        const titleParts = this.variantTitle.split(" / ");
        if (titleParts.length) {
          titleParts[this.cantidadPosition - 1] = newQuantity;
        };
        const updatedTitle = titleParts.join(" / ");
        const variant = this.VariantsJson.find(variant => variant.title === updatedTitle);

        this.quickAddBtn.setAttribute("variant-id", variant?.id);
        this.cantidadField.value = newQuantity;
        this.loader.style.display = 'flex';
  
        try {
            const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: this.lineKey,
                    quantity: 0,
                    sections: [this.sectionId, "cart-bubble"],
                    sections_url: window.location.pathname
                })
            });
    
            const data = await response.json();

            if (response.ok) {
                if (newQuantity > 0 && variant?.available) {
                    this.quickAddBtn.dispatchEvent(new Event('click'));
                }else {
                    this.cartModal.updateFromSectionHtml(data.sections[this.sectionId]);
                    document.dispatchEvent(new CustomEvent("cart-bubble-ajax-init",{
                        detail: {
                            i: data.sections["cart-bubble"].match(/\d+/)
                        }
                    }));
                }
            }
        } catch (error) {
            console.error('Error updating cart:', error);
        }
    }
}
  
customElements.define('cantidad-selector', CantidadSelector);
  